import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ConnectivityCatalogType, ConnectivityFilters } from 'src/app/domains/connectivity/models/connectivity.model';

@Component({
  selector: 'gdp-connectivity-filters',
  templateUrl: './connectivity-filters.component.html',
  styleUrls: ['./connectivity-filters.component.scss']
})
export class ConnectivityFiltersComponent implements OnInit {

  @Input() filters: ConnectivityFilters = {};
  @Output() filtersChanged = new EventEmitter<ConnectivityFilters>()
  public form: UntypedFormGroup = new UntypedFormGroup({});
  public availableFilters = ['brand', 'type', 'created_at', 'updated_at'].sort();
  public usedFilters: string[] = ['model'];
  public entryTypes: ConnectivityCatalogType[] = [ConnectivityCatalogType.modem_router, ConnectivityCatalogType.internet_key];
  public disabledItem: boolean = false;

  constructor(private calendar: NgbCalendar) { }

  ngOnInit() {
    window['obj'] = this;
    this.initFilters();
  }

  private initFilters() {
    Object.keys(this.filters).forEach((k: string) => {
      this.addFilterToUsed(k);
    });
    this.usedFilters.forEach(el => {
      this.addFormControls(el);
    });
  }

  private addFormControls(value) {
    switch (value) {
      case 'type':
        this.form.addControl(value, new UntypedFormControl(this.filters[value] || this.entryTypes[0]));
        break;
      default:
        this.form.addControl(value, new UntypedFormControl(this.filters[value]));
        break;
    }
  }

  public addFilter(filter?: string) {
    const f = filter || this.availableFilters[0];
    this.addFilterToUsed(f);
    this.addFormControls(f);
  }

  public removeFilter(filter?: string) {
    const f = filter || this.usedFilters[0];
    this.addFilterToAvailable(f);
    this.form.removeControl(f);
  }

  public emitFilters() {
    if (this.form.valid) {
      let value: ConnectivityFilters = Object.assign({}, this.form.value);
      value.brand && value.brand.length < 1 && delete value.brand;
      value.model && value.model.length < 1 && delete value.model;
      value = this.formatOutput(value);
      this.filtersChanged.emit(value);
    }
  }

  public updateFilters(newFilter: string, oldFilter: string) {
    this.removeFilter(oldFilter);
    this.addFilter(newFilter);
  }

  public resetFilters() {
    this.form = new UntypedFormGroup({});
    this.availableFilters = ['brand', 'type', 'created_at', 'updated_at'].sort();
    this.usedFilters = ['model'];
    this.initFilters();
  }

  public onSelectEntryType(type: ConnectivityCatalogType) {
    this.form.controls.type.setValue(type);
  }

  private addFilterToUsed(filter: string) {
    if (!this.availableFilters.includes(filter)) return;
    const filterIdx = this.availableFilters.indexOf(filter);
    this.usedFilters.push(filter);
    this.availableFilters.splice(filterIdx, 1);
  }

  private addFilterToAvailable(filter: string) {
    if (!this.usedFilters.includes(filter)) return;
    const filterIdx = this.usedFilters.indexOf(filter);
    this.availableFilters.push(filter);
    this.usedFilters.splice(filterIdx, 1);
    this.availableFilters.sort();
  }

  private formatOutput(filters: ConnectivityFilters) {
    let result = {};
    Object.keys(filters).forEach((k: string) => {
      if (k === 'created_at' || k === 'updated_at') {
        if (!filters[k]) return;
        result[`${k}_from`] = this.formatDate(filters[k]);
        result[`${k}_to`] = this.formatDate(this.calendar.getNext(filters[k]));
      } else if (filters[k]) {
        result[k] = filters[k];
      }
    });
    return result;
  }

  private formatDate(date: NgbDate) {
    return `${date.year}-${date.month.toString().padStart(2, '0')}-${date.day.toString().padStart(2, '0')}`;
  }
}
